import { useMemo } from 'react';

import axios, { Axios } from 'axios';

import { oimApiConfig } from '../../config';
import { useAuthorization } from '../../utils/Api';

import { TwilioAccountModel } from './types';

export type CreateTwilioAccountParams = Partial<Omit<TwilioAccountModel, 'twilioAccountId'>>;
const route = '/twilio-accounts';

class TwilioAccountsService {
  constructor(private readonly http: Axios) { }

  async createTwilioAccount(params: CreateTwilioAccountParams): Promise<TwilioAccountModel> {
    const { data } = await this.http.post<TwilioAccountModel>(route, params);

    return data;
  }

  async getTwilioAccounts(): Promise<TwilioAccountModel[]> {
    const { data } = await this.http.get<TwilioAccountModel[]>(route);

    return data;
  }
}

export const useTwilioAccountsService = () => {
  const http = axios.create({
    baseURL: oimApiConfig.apiBaseUrl,
  });

  useAuthorization(http);

  return useMemo(() => new TwilioAccountsService(http), [http]);
};
